export default __webpack_public_path__ + "static/media/rupee-icon.774c5f63.png";